import LocalImages from "assets/images/local-images";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import { FC, ReactNode } from "react";

import LinkContent from "./styles/LinkContent.styled";
import LinkWrapper from "./styles/LinkWrapper.styled";
import StyledLinkButton from "./styles/StyledLinkButton.styled";

interface LinkButtonProps {
  onClick: () => void;
  children: ReactNode;
  backLink?: boolean;
}

const LinkButton: FC<LinkButtonProps> = ({ children, backLink, onClick }) => {
  return (
    <StyledLinkButton type="button" onClick={onClick}>
      <LinkWrapper>
        <LinkContent>
          {backLink && (
            <img
              className="back-chevron"
              alt="back arrow"
              src={LocalImages.shared.images.icons.chevron.right}
            />
          )}
          <ButtonTitle as="span">{children}</ButtonTitle>
          {!backLink && (
            <img
              className="forward-chevron"
              alt="forward arrow"
              src={LocalImages.shared.images.icons.chevron.right}
            />
          )}
        </LinkContent>
      </LinkWrapper>
    </StyledLinkButton>
  );
};

export default LinkButton;
